module.exports = "/assets/data/ebdf7b1aa610f21bd30bb731e103cd82-HX7.data.json";